import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import { apiAction as getUsersApiAction } from './getUsers';

const actions = createActions({
  ADMIN: {
    CHANGE_USER_INDUSTRY: (userId, industryId) => ({ userId, industryId }),
    API: {
      CHANGE_USER_INDUSTRY: apiResourceActionCreator('userIndustry')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/change-industry/${payload.userId}/${payload.industryId}`, authToken, {}, actions.admin.api.changeUserIndustry);

function* changeUserIndustry(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));

  const result = yield apiActionResult(actions.admin.api.changeUserIndustry);

  if (result.success) {
    yield put(getUsersApiAction(authToken));
  }
}

const configuration = {
  name: 'changeUserIndustry',
  action: actions,
  sagas: changeUserIndustry,
  reducers: {
    request: (state, action) => ({
      ...state,
      isChangingIndustry: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isChangingIndustry: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isChangingIndustry: false,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/changeUserIndustry.js